module.exports = __webpack_public_path__ + "img/normalisation.eaae6e48.png";